import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { AuthContext } from '../App';
import { ArrowLeftIcon, UserIcon, BellIcon, GlobeIcon, ShieldIcon, MoonIcon, LogOutIcon, CheckIcon } from 'lucide-react';
export const Settings: React.FC = () => {
  const navigate = useNavigate();
  const {
    handleLogout
  } = useContext(AuthContext);
  // State for toggle switches
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [pushNotifications, setPushNotifications] = useState(true);
  const [metricUnits, setMetricUnits] = useState(true);
  const [darkMode, setDarkMode] = useState(false);
  const [shareData, setShareData] = useState(true);
  const onLogout = () => {
    // Just call handleLogout without navigating - let the App component handle the redirect
    handleLogout();
  };
  return <div data-id="element-1467">
      <Link to="/profile" className="flex items-center text-primary mb-4" data-id="element-1468">
        <ArrowLeftIcon size={16} className="mr-1" data-id="element-1469" />
        <span data-id="element-1470">Back to Profile</span>
      </Link>
      <div className="flex justify-between items-center mb-6" data-id="element-1471">
        <h1 className="text-2xl font-bold text-navy" data-id="element-1472">Settings</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1473">
        {/* Sidebar Navigation */}
        <div className="md:col-span-1" data-id="element-1474">
          <Card className="sticky top-4" data-id="element-1475">
            <nav className="space-y-1" data-id="element-1476">
              <a href="#account" className="flex items-center p-3 rounded-lg bg-primary/10 text-primary font-medium" data-id="element-1477">
                <UserIcon size={18} className="mr-3" data-id="element-1478" />
                Account
              </a>
              <a href="#notifications" className="flex items-center p-3 rounded-lg hover:bg-gray-100 text-gray-700" data-id="element-1479">
                <BellIcon size={18} className="mr-3" data-id="element-1480" />
                Notifications
              </a>
              <a href="#preferences" className="flex items-center p-3 rounded-lg hover:bg-gray-100 text-gray-700" data-id="element-1481">
                <GlobeIcon size={18} className="mr-3" data-id="element-1482" />
                Preferences
              </a>
              <a href="#privacy" className="flex items-center p-3 rounded-lg hover:bg-gray-100 text-gray-700" data-id="element-1483">
                <ShieldIcon size={18} className="mr-3" data-id="element-1484" />
                Privacy
              </a>
              <a href="#devices" className="flex items-center p-3 rounded-lg hover:bg-gray-100 text-gray-700" data-id="element-1485">
                <div size={18} className="mr-3" data-id="element-1486" />
                Connected Devices
              </a>
              <a href="#appearance" className="flex items-center p-3 rounded-lg hover:bg-gray-100 text-gray-700" data-id="element-1487">
                <MoonIcon size={18} className="mr-3" data-id="element-1488" />
                Appearance
              </a>
            </nav>
            <div className="mt-6 pt-6 border-t" data-id="element-1489">
              <Button variant="outline" fullWidth className="text-warning" icon={<LogOutIcon size={16} data-id="element-1491" />} onClick={onLogout} data-id="element-1490">
                Log Out
              </Button>
            </div>
          </Card>
        </div>
        {/* Settings Content */}
        <div className="md:col-span-3 space-y-6" data-id="element-1492">
          {/* Account Settings */}
          <section id="account" data-id="element-1493">
            <Card data-id="element-1494">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1495">Account Settings</h2>
              <div className="space-y-4" data-id="element-1496">
                <div data-id="element-1497">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1498">
                    Email Address
                  </label>
                  <input type="email" value="alex.johnson@example.com" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1499" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1500">
                  <div data-id="element-1501">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1502">
                      First Name
                    </label>
                    <input type="text" value="Alex" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1503" />
                  </div>
                  <div data-id="element-1504">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1505">
                      Last Name
                    </label>
                    <input type="text" value="Johnson" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1506" />
                  </div>
                </div>
                <div data-id="element-1507">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1508">
                    Location
                  </label>
                  <input type="text" value="Sydney, Australia" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1509" />
                </div>
                <div data-id="element-1510">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1511">
                    Bio
                  </label>
                  <textarea rows={3} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" defaultValue="Passionate diver with a love for underwater photography. I've been diving for 2 years and enjoy exploring coral reefs and marine life around Australia and Southeast Asia." data-id="element-1512" />
                </div>
              </div>
              <div className="border-t mt-6 pt-6" data-id="element-1513">
                <h3 className="font-medium mb-4" data-id="element-1514">Change Password</h3>
                <div className="space-y-4" data-id="element-1515">
                  <div data-id="element-1516">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1517">
                      Current Password
                    </label>
                    <input type="password" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" placeholder="••••••••" data-id="element-1518" />
                  </div>
                  <div data-id="element-1519">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1520">
                      New Password
                    </label>
                    <input type="password" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" placeholder="••••••••" data-id="element-1521" />
                  </div>
                  <div data-id="element-1522">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1523">
                      Confirm New Password
                    </label>
                    <input type="password" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" placeholder="••••••••" data-id="element-1524" />
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-6" data-id="element-1525">
                <Button variant="primary" data-id="element-1526">Save Changes</Button>
              </div>
            </Card>
          </section>
          {/* Notifications */}
          <section id="notifications" data-id="element-1527">
            <Card data-id="element-1528">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1529">
                Notification Settings
              </h2>
              <div className="space-y-4" data-id="element-1530">
                <div className="flex items-center justify-between py-2" data-id="element-1531">
                  <div data-id="element-1532">
                    <h3 className="font-medium" data-id="element-1533">Email Notifications</h3>
                    <p className="text-sm text-gray-500" data-id="element-1534">
                      Receive dive updates and community activity via email
                    </p>
                  </div>
                  <button className={`w-12 h-6 rounded-full ${emailNotifications ? 'bg-primary' : 'bg-gray-300'} relative transition-colors duration-200`} onClick={() => setEmailNotifications(!emailNotifications)} data-id="element-1535">
                    <span className={`absolute top-1 ${emailNotifications ? 'right-1' : 'left-1'} bg-white w-4 h-4 rounded-full transition-all duration-200`} data-id="element-1536"></span>
                  </button>
                </div>
                <div className="flex items-center justify-between py-2 border-t" data-id="element-1537">
                  <div data-id="element-1538">
                    <h3 className="font-medium" data-id="element-1539">Push Notifications</h3>
                    <p className="text-sm text-gray-500" data-id="element-1540">
                      Receive alerts on your device
                    </p>
                  </div>
                  <button className={`w-12 h-6 rounded-full ${pushNotifications ? 'bg-primary' : 'bg-gray-300'} relative transition-colors duration-200`} onClick={() => setPushNotifications(!pushNotifications)} data-id="element-1541">
                    <span className={`absolute top-1 ${pushNotifications ? 'right-1' : 'left-1'} bg-white w-4 h-4 rounded-full transition-all duration-200`} data-id="element-1542"></span>
                  </button>
                </div>
                <div className="border-t pt-4" data-id="element-1543">
                  <h3 className="font-medium mb-2" data-id="element-1544">Notify me about:</h3>
                  <div className="space-y-2" data-id="element-1545">
                    <div className="flex items-center" data-id="element-1546">
                      <input type="checkbox" id="notify-messages" defaultChecked className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1547" />
                      <label htmlFor="notify-messages" className="ml-2 text-gray-700" data-id="element-1548">
                        New messages
                      </label>
                    </div>
                    <div className="flex items-center" data-id="element-1549">
                      <input type="checkbox" id="notify-events" defaultChecked className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1550" />
                      <label htmlFor="notify-events" className="ml-2 text-gray-700" data-id="element-1551">
                        Upcoming dive events
                      </label>
                    </div>
                    <div className="flex items-center" data-id="element-1552">
                      <input type="checkbox" id="notify-buddies" defaultChecked className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1553" />
                      <label htmlFor="notify-buddies" className="ml-2 text-gray-700" data-id="element-1554">
                        Dive buddy requests
                      </label>
                    </div>
                    <div className="flex items-center" data-id="element-1555">
                      <input type="checkbox" id="notify-comments" defaultChecked className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1556" />
                      <label htmlFor="notify-comments" className="ml-2 text-gray-700" data-id="element-1557">
                        Comments on your posts
                      </label>
                    </div>
                    <div className="flex items-center" data-id="element-1558">
                      <input type="checkbox" id="notify-marketing" className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1559" />
                      <label htmlFor="notify-marketing" className="ml-2 text-gray-700" data-id="element-1560">
                        Marketing and promotions
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-6" data-id="element-1561">
                <Button variant="primary" data-id="element-1562">Save Preferences</Button>
              </div>
            </Card>
          </section>
          {/* Preferences */}
          <section id="preferences" data-id="element-1563">
            <Card data-id="element-1564">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1565">Dive Preferences</h2>
              <div className="space-y-4" data-id="element-1566">
                <div className="flex items-center justify-between py-2" data-id="element-1567">
                  <div data-id="element-1568">
                    <h3 className="font-medium" data-id="element-1569">Units of Measurement</h3>
                    <p className="text-sm text-gray-500" data-id="element-1570">
                      {metricUnits ? 'Metric (meters, Celsius)' : 'Imperial (feet, Fahrenheit)'}
                    </p>
                  </div>
                  <button className={`w-12 h-6 rounded-full ${metricUnits ? 'bg-primary' : 'bg-gray-300'} relative transition-colors duration-200`} onClick={() => setMetricUnits(!metricUnits)} data-id="element-1571">
                    <span className={`absolute top-1 ${metricUnits ? 'right-1' : 'left-1'} bg-white w-4 h-4 rounded-full transition-all duration-200`} data-id="element-1572"></span>
                  </button>
                </div>
                <div className="border-t pt-4" data-id="element-1573">
                  <h3 className="font-medium mb-2" data-id="element-1574">
                    Default Dive Log Settings
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3" data-id="element-1575">
                    <div data-id="element-1576">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1577">
                        Default Dive Type
                      </label>
                      <select className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1578">
                        <option data-id="element-1579">Boat Dive</option>
                        <option data-id="element-1580">Shore Dive</option>
                        <option data-id="element-1581">Drift Dive</option>
                        <option data-id="element-1582">Night Dive</option>
                        <option data-id="element-1583">Deep Dive</option>
                        <option data-id="element-1584">Cave Dive</option>
                        <option data-id="element-1585">Wreck Dive</option>
                      </select>
                    </div>
                    <div data-id="element-1586">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1587">
                        Gas Type
                      </label>
                      <select className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1588">
                        <option data-id="element-1589">Air</option>
                        <option data-id="element-1590">Nitrox</option>
                        <option data-id="element-1591">Trimix</option>
                        <option data-id="element-1592">Heliox</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="border-t pt-4" data-id="element-1593">
                  <h3 className="font-medium mb-2" data-id="element-1594">Default Equipment</h3>
                  <div className="space-y-2" data-id="element-1595">
                    <div className="flex items-center" data-id="element-1596">
                      <input type="checkbox" id="equip-bcd" defaultChecked className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1597" />
                      <label htmlFor="equip-bcd" className="ml-2 text-gray-700" data-id="element-1598">
                        BCD
                      </label>
                    </div>
                    <div className="flex items-center" data-id="element-1599">
                      <input type="checkbox" id="equip-regulator" defaultChecked className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1600" />
                      <label htmlFor="equip-regulator" className="ml-2 text-gray-700" data-id="element-1601">
                        Regulator
                      </label>
                    </div>
                    <div className="flex items-center" data-id="element-1602">
                      <input type="checkbox" id="equip-computer" defaultChecked className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1603" />
                      <label htmlFor="equip-computer" className="ml-2 text-gray-700" data-id="element-1604">
                        Dive Computer
                      </label>
                    </div>
                    <div className="flex items-center" data-id="element-1605">
                      <input type="checkbox" id="equip-wetsuit" defaultChecked className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1606" />
                      <label htmlFor="equip-wetsuit" className="ml-2 text-gray-700" data-id="element-1607">
                        Wetsuit
                      </label>
                    </div>
                    <div className="flex items-center" data-id="element-1608">
                      <input type="checkbox" id="equip-camera" defaultChecked className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1609" />
                      <label htmlFor="equip-camera" className="ml-2 text-gray-700" data-id="element-1610">
                        Camera
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-6" data-id="element-1611">
                <Button variant="primary" data-id="element-1612">Save Preferences</Button>
              </div>
            </Card>
          </section>
          {/* Privacy */}
          <section id="privacy" data-id="element-1613">
            <Card data-id="element-1614">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1615">Privacy Settings</h2>
              <div className="space-y-4" data-id="element-1616">
                <div className="flex items-center justify-between py-2" data-id="element-1617">
                  <div data-id="element-1618">
                    <h3 className="font-medium" data-id="element-1619">Profile Visibility</h3>
                    <p className="text-sm text-gray-500" data-id="element-1620">
                      Who can see your profile
                    </p>
                  </div>
                  <select className="p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1621">
                    <option data-id="element-1622">Everyone</option>
                    <option data-id="element-1623">Dive Buddies Only</option>
                    <option data-id="element-1624">Private</option>
                  </select>
                </div>
                <div className="flex items-center justify-between py-2 border-t" data-id="element-1625">
                  <div data-id="element-1626">
                    <h3 className="font-medium" data-id="element-1627">Dive Log Visibility</h3>
                    <p className="text-sm text-gray-500" data-id="element-1628">
                      Who can see your dive logs
                    </p>
                  </div>
                  <select className="p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1629">
                    <option data-id="element-1630">Everyone</option>
                    <option data-id="element-1631">Dive Buddies Only</option>
                    <option data-id="element-1632">Private</option>
                  </select>
                </div>
                <div className="flex items-center justify-between py-2 border-t" data-id="element-1633">
                  <div data-id="element-1634">
                    <h3 className="font-medium" data-id="element-1635">Share Dive Data</h3>
                    <p className="text-sm text-gray-500" data-id="element-1636">
                      Share anonymized dive data to improve the platform
                    </p>
                  </div>
                  <button className={`w-12 h-6 rounded-full ${shareData ? 'bg-primary' : 'bg-gray-300'} relative transition-colors duration-200`} onClick={() => setShareData(!shareData)} data-id="element-1637">
                    <span className={`absolute top-1 ${shareData ? 'right-1' : 'left-1'} bg-white w-4 h-4 rounded-full transition-all duration-200`} data-id="element-1638"></span>
                  </button>
                </div>
                <div className="border-t pt-4" data-id="element-1639">
                  <h3 className="font-medium mb-2" data-id="element-1640">Data Management</h3>
                  <div className="space-y-3" data-id="element-1641">
                    <Button variant="outline" size="sm" data-id="element-1642">
                      Download My Data
                    </Button>
                    <div data-id="element-1643">
                      <Button variant="outline" size="sm" className="text-warning" data-id="element-1644">
                        Delete My Account
                      </Button>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-1645">
                        This will permanently delete all your data and cannot be
                        undone.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-6" data-id="element-1646">
                <Button variant="primary" data-id="element-1647">Save Privacy Settings</Button>
              </div>
            </Card>
          </section>
          {/* Connected Devices */}
          <section id="devices" data-id="element-1648">
            <Card data-id="element-1649">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1650">Connected Devices</h2>
              <div className="space-y-4" data-id="element-1651">
                <div className="flex items-center justify-between py-3 border-b" data-id="element-1652">
                  <div className="flex items-start gap-3" data-id="element-1653">
                    <div className="p-2 rounded-full bg-primary/10 text-primary" data-id="element-1654">
                      <div size={24} data-id="element-1655" />
                    </div>
                    <div data-id="element-1656">
                      <h3 className="font-medium" data-id="element-1657">Garmin Descent G1</h3>
                      <p className="text-sm text-gray-500" data-id="element-1658">
                        Dive Computer • Connected 2 weeks ago
                      </p>
                      <Badge variant="success" className="mt-1" data-id="element-1659">
                        Active
                      </Badge>
                    </div>
                  </div>
                  <Button variant="outline" size="sm" data-id="element-1660">
                    Disconnect
                  </Button>
                </div>
                <div className="flex items-center justify-between py-3 border-b" data-id="element-1661">
                  <div className="flex items-start gap-3" data-id="element-1662">
                    <div className="p-2 rounded-full bg-primary/10 text-primary" data-id="element-1663">
                      <div size={24} data-id="element-1664" />
                    </div>
                    <div data-id="element-1665">
                      <h3 className="font-medium" data-id="element-1666">Olympus TG-6</h3>
                      <p className="text-sm text-gray-500" data-id="element-1667">
                        Camera • Connected 1 month ago
                      </p>
                      <Badge variant="success" className="mt-1" data-id="element-1668">
                        Active
                      </Badge>
                    </div>
                  </div>
                  <Button variant="outline" size="sm" data-id="element-1669">
                    Disconnect
                  </Button>
                </div>
                <div className="pt-4" data-id="element-1670">
                  <Button variant="outline" icon={<div size={16} data-id="element-1672" />} data-id="element-1671">
                    Connect New Device
                  </Button>
                  <p className="text-sm text-gray-500 mt-2" data-id="element-1673">
                    Connect your dive computer, camera, or other devices to
                    automatically sync your dive data.
                  </p>
                </div>
              </div>
            </Card>
          </section>
          {/* Appearance */}
          <section id="appearance" data-id="element-1674">
            <Card data-id="element-1675">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1676">Appearance</h2>
              <div className="space-y-4" data-id="element-1677">
                <div className="flex items-center justify-between py-2" data-id="element-1678">
                  <div data-id="element-1679">
                    <h3 className="font-medium" data-id="element-1680">Dark Mode</h3>
                    <p className="text-sm text-gray-500" data-id="element-1681">Use dark theme</p>
                  </div>
                  <button className={`w-12 h-6 rounded-full ${darkMode ? 'bg-primary' : 'bg-gray-300'} relative transition-colors duration-200`} onClick={() => setDarkMode(!darkMode)} data-id="element-1682">
                    <span className={`absolute top-1 ${darkMode ? 'right-1' : 'left-1'} bg-white w-4 h-4 rounded-full transition-all duration-200`} data-id="element-1683"></span>
                  </button>
                </div>
                <div className="border-t pt-4" data-id="element-1684">
                  <h3 className="font-medium mb-3" data-id="element-1685">Color Theme</h3>
                  <div className="grid grid-cols-4 gap-3" data-id="element-1686">
                    <div className="relative" data-id="element-1687">
                      <div className="h-12 rounded-lg bg-primary cursor-pointer border-2 border-primary" data-id="element-1688"></div>
                      <CheckIcon size={16} className="absolute top-1 right-1 text-white" data-id="element-1689" />
                    </div>
                    <div className="h-12 rounded-lg bg-blue-600 cursor-pointer" data-id="element-1690"></div>
                    <div className="h-12 rounded-lg bg-green-600 cursor-pointer" data-id="element-1691"></div>
                    <div className="h-12 rounded-lg bg-purple-600 cursor-pointer" data-id="element-1692"></div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-6" data-id="element-1693">
                <Button variant="primary" data-id="element-1694">Save Appearance</Button>
              </div>
            </Card>
          </section>
        </div>
      </div>
    </div>;
};